import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=484dbb12&"
import script from "./CourseCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=484dbb12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports